export const normalizeError = (error: unknown): Error => {
	if (!(error instanceof Error)) {
		return new Error(`received non-error value ${JSON.stringify(error)}`);
	}
	return error;
};
